import React, { useEffect, useState } from "react";
import "./RadioGroupField.css";
import { Radio } from "antd";

const RadioGroupField = (props) => {
  const dataList = props.item && props.item.text_data;
  const selection = props?.item?.text_data?.disableSelection === true;
  const defaultValue = props?.item?.text_data?.defaultValue;
  const [selectedValue, setSelectedValue] = useState(defaultValue || null);

  useEffect(() => {
    if (defaultValue) {
      setSelectedValue(defaultValue);
      setTimeout(() => {
        props?.setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          updatedErrors[props?.index] = {
            key1: defaultValue,
            displayName: defaultValue,
          };
          return updatedErrors;
        });
      }, 1000);
    }
  }, [defaultValue, props.index]);

  const handleChange = (e) => {
    if (selection) return;
    const value = e.target.value;
    const selectedOption = dataList?.data?.find((item) => item.value === value);
    const displayName = selectedOption?.name || "";

    if (value) {
      props?.inputValue?.current?.removeAttribute("disabled");
    } else {
      props?.inputValue?.current?.setAttribute("disabled", true);
    }

    props?.setErrors((prevErrors) => {
      const updatedErrors = {
        ...prevErrors,
        [props?.index]: { key1: value, displayName },
      };
      return updatedErrors;
    });

    localStorage.setItem(
      "inputValue",
      JSON.stringify({ key1: value, displayName })
    );

    setSelectedValue(value);
  };

  return (
    <div
      className="form-group action-tab"
      style={{ width: "90%", margin: "14px 14px 14px 4px" }}
    >
      <div className={`radio-group-outer-box error-${props?.index}`}>
        <Radio.Group
          onChange={handleChange}
          value={selectedValue}
          className={`radio-group `}
          disabled={selection}
        >
          {dataList?.data?.map((item) => (
            <div key={item.value} className="radio-box">
              <Radio value={item.value}>{item.name}</Radio>
            </div>
          ))}
        </Radio.Group>
      </div>
      <span className="validate">&nbsp;</span>
    </div>
  );
};

export default RadioGroupField;
